import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useOrgCommunityExpertiseFeedStore = defineSmartFeedPiniaStore(
  "org-community-expertise-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/expert/community";
      },
    },
  },
);
